module.exports={
	"Form": "AccountTypeEditManifest",
	"Scope": "AccountType-Edit",
	"Descriptors":
	{
		"AccountTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "AccountType-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AccountType-Edit-Identity",
				"Group": "AccountType-Edit-Identity"
			}
		},
		"AccountTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "AccountType-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-Edit-Details",
				"Group": "AccountType-Edit-Details"
			}
		},
		"AccountTypeDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "AccountType-Edit-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "AccountType-Edit-Details",
				"Group": "AccountType-Edit-Details"
			}
		},
		"AccountTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "AccountType-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "AccountType-Edit-Details",
				"Group": "AccountType-Edit-Details"
			}
		},
		"AccountTypeDetails.IDAccountType":
		{
			"Name": "IDAccount Type",
			"Hash": "AccountType-Edit-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.GUIDAccountType":
		{
			"Name": "GUIDAccount Type",
			"Hash": "AccountType-Edit-GUIDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AccountType-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AccountType-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AccountType-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		},
		"AccountTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AccountType-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "AccountType-Edit-DataAudit",
				"Group": "AccountType-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AccountType-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AccountType-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AccountType-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AccountType-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AccountType-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AccountType-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
